import { useState, useEffect } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useFetchAdUnits = (active, refresh) => {
  const [adUnitsResponse, setAdUnitsResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdUnits = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await axiosService.get(
          `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-ad-unit-service/v1/get/all?active=${active}&limit=100&page=1`
        );

        setAdUnitsResponse(response?.data);
      } catch (err) {
        console.error(err);
        setError(err.message || 'An error occurred while fetching ad units');
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdUnits();

  }, [active, refresh]); // Fetch ad units whenever the 'active' parameter changes

  return [ adUnitsResponse, isLoading, error ];
};